import axiosConfig from "../../../config/axiosConfig";
import {
  EXCLUDE_CALC_URL,
  PRICING_RP_UPDATE_URL,
  PRICING_URL,
  SUMMRY_URL,
  UPDATE_BULK_RP_PRICING_URL,
} from "../../../config/config";
import {
  buildPayloadForColumnEdit,
  createQueryParams,
  getStringFromArray,
} from "../../../utils/helper";

let controller = null;

export const cancelPricingRequest = () => {
  if (controller) {
    controller.abort();
    controller = null;
  }
};

export const GetPricingService = (params) => {
  // Cancel any previous request (request cancellation implementation because when one request is ongoing and use change the engine pricing tab. e.g. from LLP to Non-LLP or LRU, then previous request should be cancelled)
  cancelPricingRequest();

  // Create new AbortController
  controller = new AbortController();

  try {
    const {
      page,
      per_page,
      ordering,
      type,
      slug,
      comp_type,
      part_number,
      serial_number,
      description,
      lookup_pn,
      actual_pn,
      clp,
      module,
      delivery_cr,
      initial_delivery_net_sales,
      eol_cr,
      net_sales,
      sales,
      repair_cost,
      per_cycle,
      current_cr,
      mod,
      typical_pn,
      benign_scrap_rate,
      expected_yield,
      sales_total,
      is_exclude,
      part_tier,
      ipc_ref,
      ata_chapter,
      part_class_description,
      rp,
      update,
    } = params || {};

    const paramsList = {
      page,
      per_page,
      ordering,
      part_number,
      serial_number,
      description,
      lookup_pn,
      actual_pn,
      clp,
      module,
      delivery_cr,
      initial_delivery_net_sales,
      eol_cr,
      net_sales,
      sales,
      repair_cost,
      per_cycle,
      current_cr,
      mod,
      ipc_ref,
      typical_pn,
      tier: getStringFromArray(part_tier),
      // part_tier: getStringFromArray(part_tier),
      benign_scrap_rate,
      expected_yield,
      sales_total,
      is_exclude: is_exclude ? is_exclude : undefined,
      ata_chapter,
      part_class_description: getStringFromArray(part_class_description),
      repair_percent: rp,
      update,
    };

    const queryString = createQueryParams(paramsList);

    const url = comp_type
      ? `${PRICING_URL}/${type}/${slug}/${comp_type}${queryString ? `?${queryString}` : ""}`
      : `${PRICING_URL}/${type}/${slug}${queryString ? `?${queryString}` : ""}`;

    return axiosConfig.get(url, {
      signal: controller?.signal,
    });
  } catch (error) {
    throw error;
  }
};

export const GetPricingSummaryService = (params) => {
  try {
    const { type, slug, rp } = params || {};
    const paramsList = {
      repair_percent: rp,
    };
    const queryString = createQueryParams(paramsList);
    const url = `${PRICING_URL}/${type}/${slug}/summary${queryString ? `?${queryString}` : ""}`;
    return axiosConfig.get(url);
  } catch (error) {
    throw error;
  }
};

export const UpdatePricingService = (params) => {
  try {
    const { update, type, slug, rp, slug_list } = params || {};
    const paramsList = {
      update,
    };

    const queryString = createQueryParams(paramsList);

    const url = `${PRICING_URL}/${type}/${slug}${queryString ? `?${queryString}` : ""}`;

    return axiosConfig.patch(url, { repair_percent: rp, slug_list });
  } catch (error) {
    throw error;
  }
};

export const UpdateRPPricingService = (params) => {
  try {
    const { slug, rp, slug_list } = params || {};

    const url = `${UPDATE_BULK_RP_PRICING_URL}/${slug}`;

    return axiosConfig.patch(url, { repair_percent: rp, slug_list });
  } catch (error) {
    throw error;
  }
};

export const ExcludeCalcService = (params) => {
  try {
    const { exclude_slug, asset_type, include_slug, engine_pricing_type } =
      params || {};
    return axiosConfig.post(`${EXCLUDE_CALC_URL}`, {
      exclude_slug,
      include_slug,
      asset_type,
      engine_pricing_type: engine_pricing_type ?? undefined,
    });
  } catch (error) {
    throw error;
  }
};

export const UpdateRepairPercentageServicePricing = ({ data, params }) => {
  const { slug } = params || {};
  const url = `${PRICING_RP_UPDATE_URL}/${slug}`;
  return axiosConfig.patch(url, data);
};

export const GetSummryDataServicePricing = async (params) => {
  try {
    const url = `${SUMMRY_URL}?project_assets_slug=${encodeURIComponent(params.project_assets_slug)}`;
    return await axiosConfig.get(url);
  } catch (error) {
    console.error("Error in GetSummryDataServicePricing:", error);
    throw error;
  }
};

export const UpdatePricingColumnService = (params) => {
  try {
    const { type, slug, comp_end_point } = params || {};

    const url = comp_end_point
      ? `${PRICING_URL}/${type}/${slug}/${comp_end_point}`
      : `${PRICING_URL}/${type}/${slug}`;

    const keys = [
      "sales_clp",
      "current_repairs_per_ea",
      "clp",
      "avg_repair_cost",
      "sales_total",
      "actual_pn",
      "typical_pn",
      "sales",
      "repair_cost",
      "csn",
      "benign_scrap_rate",
      "harsh_scrap_rate",
    ];

    const payload = buildPayloadForColumnEdit({ params, keys });

    return axiosConfig.patch(url, payload);
  } catch (error) {
    throw error;
  }
};

export const UpdateLlpBulkCsnService = ({ slug, csn }) => {
  const url = `${PRICING_URL}/esn/${slug}/llp-bulk-update`;
  return axiosConfig.patch(url, { csn });
};
